module.exports = __webpack_public_path__ + "static/media/pwa1.c5b849c9.png";